import { render, staticRenderFns } from "./SalePricesRulesFilter.vue?vue&type=template&id=2c80e1fc"
import script from "./SalePricesRulesFilter.vue?vue&type=script&lang=js"
export * from "./SalePricesRulesFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports